var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconHeatmap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43027",
    "data-name": "Group 43027",
    transform: "translate(-29 -410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42978",
    "data-name": "Group 42978",
    transform: "translate(-671 88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42632",
    "data-name": "Group 42632",
    transform: "translate(-10 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42612",
    "data-name": "Group 42612",
    transform: "translate(706 325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    transform: "translate(4 3)",
    fill: "#fff",
    stroke: "#dedede",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Donut_chart",
    "data-name": "Donut chart",
    transform: "translate(553 92.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 24,
    height: 24,
    transform: "translate(150 232.001)",
    fill: "#e0e0e0",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42982",
    "data-name": "Group 42982",
    transform: "translate(2.139 2.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_List_Numbered_120493",
    "data-name": "noun_List Numbered_120493",
    transform: "translate(33 414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42995",
    "data-name": "Group 42995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43001",
    "data-name": "Group 43001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10081",
    "data-name": "Rectangle 10081",
    transform: "translate(-0.139 -0.139)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43000",
    "data-name": "Group 43000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42999",
    "data-name": "Group 42999"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 17,
    transform: "translate(0.361 4.361)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 17,
    transform: "translate(0.361 8.361)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 17,
    transform: "translate(0.361 12.361)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10092",
    "data-name": "Rectangle 10092",
    transform: "translate(8.861 12.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10093",
    "data-name": "Rectangle 10093",
    transform: "translate(8.861 7.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10094",
    "data-name": "Rectangle 10094",
    transform: "translate(4.861 4.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10095",
    "data-name": "Rectangle 10095",
    transform: "translate(4.861 8.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10098",
    "data-name": "Rectangle 10098",
    transform: "translate(12.861 0.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10096",
    "data-name": "Rectangle 10096",
    transform: "translate(0.861 8.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10097",
    "data-name": "Rectangle 10097",
    transform: "translate(0.861 12.861)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42998",
    "data-name": "Group 42998"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 17,
    transform: "translate(12.861 0.428) rotate(90)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 17,
    transform: "translate(8.861 0.428) rotate(90)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 17,
    transform: "translate(4.861 0.428) rotate(90)",
    fill: "none",
    stroke: "#85888a",
    strokeWidth: 1.5
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconHeatmap);
export default __webpack_public_path__ + "static/media/chart-icon-heatmap.b8b2b7a7.svg";
export { ForwardRef as ReactComponent };